import LightGallery from 'lightgallery/react';
import { Typography, Row } from 'antd';
import { useState, useEffect } from 'react';
import axios from 'axios';
import imageDefault from '../images/image.png';
import { orderBy } from 'lodash';

// import styles
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import 'lightgallery/css/lg-video.css';
import '../styles/Galeria.css';

// import plugins if you need
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';

const { Title } = Typography;

function Galeria({ folderId, title }) {
  const [images, setImages] = useState([]);
  const [hasError, setHasError] = useState(false);
  const apiKey = process.env.REACT_APP_GOOGLE_API_KEY;

  useEffect(() => {
    const fetchFiles = async () => {
      try {
        // Fetch images
        const imageResponse = await axios.get(
          `https://www.googleapis.com/drive/v3/files`,
          {
            params: {
              q: `'${folderId}' in parents and mimeType contains 'image/'`,
              key: apiKey,
              fields: 'files(id, name)',
            },
          }
        );

        const imageFiles = imageResponse.data.files.map((file) => ({
          id: file.id,
          name: file.name,
          url: `https://drive.google.com/thumbnail?id=${file.id}&sz=s1000`, // URL for image thumbnail
        }));

        // Ordenar las imagenes segun la fecha en su nombre

        const sortedImages = orderBy(
          imageFiles,
          [(image) => extractDateFromName(image.name)?.getTime() || 0], // Extract the date
          ['desc'] // Sort in descending order (most recent first)
        );

        setImages(sortedImages); // Store the sorted images in a separate state
      } catch (error) {
        console.error('Error fetching files:', error);
        setHasError(true);
      }
    };

    fetchFiles();
  }, [folderId, apiKey]);

  // Función para extraer la fecha del nombre del archivo
  const extractDateFromName = (name) => {
    const dateRegex = /^(\d{4})\.(\d{2})\.(\d{2})/;
    const match = name.match(dateRegex);
    if (match) {
      const [, year, month, day] = match;
      return new Date(`${year}-${month}-${day}`);
    }
    return null;
  };

  // If there are no images or an error occurred, return null
  if (images.length === 0 || hasError) {
    return null;
  }

  // Limit the number of visible images to 9 (3 rows of 3 images)
  const visibleImages = images.slice(0, 15);

  return (
    <div id="galeria">
      <Row justify="center">
        <Title level={2} className="title-responsive">
          {title}
        </Title>
      </Row>
      <Row justify="center" className="gallery-row">
        <LightGallery speed={500} plugins={[lgThumbnail, lgZoom]}>
          {/* Render only the first 9 images */}
          {visibleImages.map((image) => (
            <a key={image.id} href={image.url}>
              <img
                src={image.url}
                alt={image.name}
                className="gallery-image"
                onError={(e) => {
                  e.target.src = imageDefault; // Fallback to default image
                }}
              />
            </a>
          ))}
          {/* Add hidden links for the rest of the images */}
          {images.slice(15).map((image) => (
            <a
              key={image.id}
              href={image.url}
              style={{ display: 'none' }} // Hide these links from the UI
            >
              <img src={image.url} alt={image.name} />
            </a>
          ))}
        </LightGallery>
      </Row>
    </div>
  );
}

export default Galeria;
